import styled, { css } from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { THEME } from '../../../../../../themes';
import {
  CaptionFont,
  HeadlineFont,
} from '../../../../../../themes/fonts';
import { scaleUpCenterAnimation } from '../../../../../../animations';

export const TooltipBubble = withStyles({
  tooltip: {
    display: 'flex',
    color: `${THEME.COLORS.PRIMARY_DARK}`,
    backgroundColor: `${THEME.COLORS.LIGHT_GREY}`,
    borderRadius: '24px 24px 5px 24px',
    width: 'auto !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'center',
    height: 'auto',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: 'normal',
    letterSpacing: '0.4px',
    border: `solid 2px ${THEME.COLORS.PURE_WHITE}`,
    position: 'absolute',
    top: '-12px',
    right: '-10px',
  } as const,
})(Tooltip);

export const Container = styled.div`
 display: flex;
 flex-direction: column;
 width: 100%;
 height: 100%;
`;

export const Label = styled.div`
  ${CaptionFont};
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  margin-bottom: ${THEME.SPACING.TINO};
`;

export const Title = styled.span`
  ${HeadlineFont};
  font-weight: normal;
  margin-bottom: ${THEME.SPACING.BASE};
`;

export const MarkedTitle = styled.span`
  font-weight: 600;
  margin-left: ${THEME.SPACING.MICRO};
`;

export const ChartPanel = styled.div`
  display:flex;
  flex-direction: column;
  margin-top: auto;
`;
export const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${THEME.SPACING.BASE};
`;

export const PanelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IndustryCircle = styled.div<{
  size: number,
  color: string,
  index: number,
  isEnableAnimation: boolean,
}>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-color: ${({ color }) => color};
  margin-right: ${THEME.SPACING.MICRO};
  animation: ${({ isEnableAnimation, index }) => {
    return isEnableAnimation ?
      css`${scaleUpCenterAnimation} .4s cubic-bezier(0.175, 0.885, 0.320, 1.275) 
  ${(index + 1) * 150}ms both` : 'none';
  }};

  position: relative;
`;

export const RoleCircle = styled.div<{
  size: number,
  color: string,
}>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-color: ${({ color }) => color};
  margin-right: ${THEME.SPACING.TINY};
`;

export const PlaceholderCircle = styled.div<{
  size: number,
  color: string,
}>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-color: ${({ color }) => color};
  margin-right: ${THEME.SPACING.MICRO};
  opacity: ${THEME.OPACITY.DIVIDER};
`;

export const RoleName = styled.div`
  opacity: ${THEME.OPACITY.MED};
  ${CaptionFont};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_PRIMARY};
`;

export const ExperienceValue = styled.div`
  opacity: ${THEME.OPACITY.LOW};
  ${CaptionFont};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  margin-left: auto;
`;
